<script lang="ts">
    import { untrack } from 'svelte'

    interface Props {
        // int currency: we expect a valid integer, 1 = 0.01$
        value: number | null | undefined
        // Set to null to disable; Also in "cents" ($ * 100)
        min?: number | null | undefined
        max?: number | null | undefined
        step?: number
        onchange?: (v: number | null) => void
        [key: string]: any
    }

    let { value = $bindable(), min = 0, max = undefined, step = 1, onchange = undefined, ...rest }: Props = $props()

    let editValue: number = $state(0)

    function importValue(value: number) {
        const nv = value / 100.0
        if (Math.abs(nv - editValue) > 0.01) editValue = nv
    }

    function exportValue(editValue: number) {
        const np = Math.round(editValue * 100)
        if (Math.abs(np - (value != null ? value : 0)) > 0.1) value = np
    }

    $effect(() => {
        value
        untrack(() => importValue(value != null ? value : 0))
    })
</script>

<input
    type="number"
    min={min == null ? undefined : min / 100}
    max={max == null ? undefined : max / 100}
    bind:value={
        () => editValue,
        (v) => {
            editValue = v
            exportValue(editValue)
            if (onchange) onchange(value == null ? null : value)
        }
    }
    step={step == null ? undefined : step / 100}
    {...rest}
/>
